// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6195":"fd77b30e","7815":"8cedef29","9134":"3106008f"}[chunkId] + ".chunk.css";
};